export const environment = {
  production: true,
  buildId: '3841485515123571',
  configFile: 'config.json',
};
